import { ActionType } from '../../types/action';

/** madkhol-admin's AccessGrant on `account-deletion`: read the queue, cancel (update), start and complete (delete). */
export const AccountDeletion = {
  list: { resource: 'account-deletion', action: ActionType.READ },
  cancel: { resource: 'account-deletion', action: ActionType.UPDATE },
  process: { resource: 'account-deletion', action: ActionType.DELETE },
};
